import {observer} from 'mobx-react-lite';
import {ISimpleTableColumnTarget, RadioGroup} from '@progress-fe/ui-kit';
import {hasValue} from '@progress-fe/core';
import {Box} from '@chakra-ui/react';

interface IProps<T> {
  value: T;
  rowKey?: string | number;
  selectedRowKey?: number;
  column: ISimpleTableColumnTarget<T>;
  onSelectRow: (rowKey: number) => Promise<void>;
}

const RowIdCellRendererFC = <T,>({
  value,
  column,
  rowKey,
  selectedRowKey,
  onSelectRow
}: IProps<T>) => {
  const propertyName = column.propertyName;
  const propertyValue = propertyName ? (value[propertyName] as string) : null;
  const mappedRowKey = hasValue(rowKey) ? Number(rowKey) : -1;

  return (
    <Box>
      <RadioGroup
        value={selectedRowKey?.toString()}
        options={[{value: mappedRowKey.toString(), label: propertyValue ?? ''}]}
        onChange={(v) => onSelectRow(Number(v))}
        sx={{pl: '4px'}}
      />
    </Box>
  );
};

export const RowIdCellRenderer = observer(RowIdCellRendererFC);
